export default {
  GetCategories: 'api/public/categories',
  GetCourses: 'api/public/courses',
  GettimeZones: 'api/public/timeZones',
  GetTabCourses: 'api/public/courses',
  GetCourseItem : 'api/private/courses'
};
